import { ApiResponse, post } from "../helpers";
import { RegistrationEndPoints } from "./configEndPoints";

const isReferralSetPassword = async (): Promise<ApiResponse<boolean>> => {
  return post<void, boolean>(
    RegistrationEndPoints.IsReferralSetPassword,
    undefined as void
  );
};
// eslint-disable-next-line @typescript-eslint/naming-convention
const ReferralRegistrationApi = {
  isReferralSetPassword,
};

export default ReferralRegistrationApi;
